(function(){
  var slider=document.querySelector('[data-womn-slider]');
  if(slider){
    var track=slider.querySelector('[data-womn-track]');
    var slides=[].slice.call(slider.querySelectorAll('[data-womn-slide]'));
    var dots=[].slice.call(document.querySelectorAll('[data-womn-dot]'));
    var prev=document.querySelector('[data-womn-prev]');
    var next=document.querySelector('[data-womn-next]');
    var index=0,startX=0,endX=0;
    function go(i){index=(i+slides.length)%slides.length;track.style.transform='translateX(-'+(index*100)+'%)';dots.forEach(function(d,n){d.classList.toggle('active',n===index)})}
    dots.forEach(function(d,i){d.addEventListener('click',function(){go(i)})});
    if(prev)prev.addEventListener('click',function(){go(index-1)});
    if(next)next.addEventListener('click',function(){go(index+1)});
    slider.addEventListener('touchstart',function(e){startX=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchmove',function(e){endX=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchend',function(){var diff=startX-endX;if(Math.abs(diff)>40){go(index+(diff>0?1:-1))}startX=0;endX=0});
    setInterval(function(){go(index+1)},4500); go(0);
  }

  var stickyName=document.querySelector('[data-sticky-name]'),stickyPrice=document.querySelector('[data-sticky-price]'),stickyMrp=document.querySelector('[data-sticky-mrp]'),mainCta=document.querySelector('[data-main-cta]'),mainPrice=document.querySelector('[data-main-price]'),mainMrp=document.querySelector('[data-main-mrp]'),mainSave=document.querySelector('[data-main-save]');
  var selectedOffer=document.querySelector('[data-offer-card].selected')||document.querySelector('[data-offer-card]');
  var modal=document.querySelector('[data-womn-lead-modal]'),leadForm=document.querySelector('[data-womn-lead-form]'),leadClose=document.querySelector('[data-womn-lead-close]'),leadPack=document.querySelector('[data-lead-pack]'),leadPrice=document.querySelector('[data-lead-price]'),leadSubmit=document.querySelector('[data-womn-lead-submit]'),releasitBridge=document.querySelector('[data-womn-releasit-bridge]');

  function variantFromUrl(url){
    if(!url)return '';
    try{return new URL(url,window.location.origin).searchParams.get('variant')||'';}catch(err){return '';}
  }
  function offerData(card){
    card=card||selectedOffer||{};
    var ds=card.dataset||{};
    var url=ds.checkoutUrl||'/products/cyclical-multivitamin';
    var variantId=ds.variantId||variantFromUrl(url)||'';
    return{title:ds.title||'3 Months',price:ds.price||'₹1,299',mrp:ds.mrp||'₹2,499',save:ds.save||'SAVE 48%',day:ds.day||'₹14/day',url:url,variantId:variantId,quantity:ds.quantity||'1'};
  }
  function dispatchNativeChange(el){
    if(!el)return;
    try{el.dispatchEvent(new Event('input',{bubbles:true}));}catch(err){}
    try{el.dispatchEvent(new Event('change',{bubbles:true}));}catch(err){}
  }
  function setFieldValue(el,value){
    if(!el||value===undefined||value===null||String(value)==='')return;
    var next=String(value);
    if(el.tagName==='SELECT'){
      var hasOption=false;
      for(var i=0;i<el.options.length;i++){if(String(el.options[i].value)===next){hasOption=true;break;}}
      if(!hasOption)return;
    }
    if(String(el.value||'')===next)return;
    try{
      var proto=el.tagName==='SELECT'?window.HTMLSelectElement.prototype:window.HTMLInputElement.prototype;
      var setter=Object.getOwnPropertyDescriptor(proto,'value').set;
      setter.call(el,next);
    }catch(err){el.value=next;}
    dispatchNativeChange(el);
  }
  function selectedProductUrl(data){
    var base=(data&&data.url)||'/products/cyclical-multivitamin';
    try{
      var u=new URL(base,window.location.origin);
      var variantId=data&&data.variantId?data.variantId:variantFromUrl(base);
      if(variantId)u.searchParams.set('variant',variantId);
      if(data&&data.quantity)u.searchParams.set('quantity',data.quantity);
      return u.toString();
    }catch(err){return base;}
  }
  function closestRsiSurface(el){
    var node=el;
    while(node&&node!==document.body){
      var id=(node.id||'').toLowerCase();
      var cls=(node.className&&typeof node.className==='string'?node.className:'').toLowerCase();
      if(id.indexOf('rsi')>-1||id.indexOf('releasit')>-1||cls.indexOf('rsi')>-1||cls.indexOf('releasit')>-1||cls.indexOf('cod')>-1)return node;
      node=node.parentElement;
    }
    return null;
  }
  function syncRsiScope(scope,variantId,quantity){
    if(!scope)return;
    if(variantId){
      var variantFields=scope.querySelectorAll('[data-womn-rsi-variant-select],select[name="id"],[data-womn-rsi-variant-input],input[name="id"],input[name="variant"],input[name="variant_id"],input[name="items[0][id]"]');
      variantFields.forEach(function(field){setFieldValue(field,variantId);});
    }
    var qtyFields=scope.querySelectorAll('[data-womn-rsi-quantity],input[name="quantity"],input[name="qty"],input[name="items[0][quantity]"]');
    qtyFields.forEach(function(field){setFieldValue(field,quantity||'1');});
    if(scope.setAttribute){
      scope.setAttribute('data-womn-selected-variant-id',variantId||'');
      scope.setAttribute('data-womn-selected-quantity',quantity||'1');
    }
  }
  function syncRsiContext(data,extraEl){
    data=data||offerData(selectedOffer);
    if(!data)return data;
    var variantId=data.variantId||variantFromUrl(data.url);
    var quantity=data.quantity||'1';
    var productUrl=selectedProductUrl({url:data.url,variantId:variantId,quantity:quantity});
    try{
      sessionStorage.setItem('womn_selected_variant_id',variantId||'');
      sessionStorage.setItem('womn_selected_quantity',quantity||'1');
      window.WOMN_RSI_SELECTED={variant_id:variantId||'',quantity:quantity||'1',product_url:productUrl};
    }catch(err){}
    var scopes=[];
    function add(scope){if(scope&&scopes.indexOf(scope)===-1)scopes.push(scope);}
    document.querySelectorAll('[data-womn-native-rsi-host]').forEach(function(host){
      if(productUrl)host.setAttribute('data-product-url',productUrl);
      add(host);
    });
    if(extraEl)add(closestRsiSurface(extraEl));
    document.querySelectorAll('form[action*="/cart/add"],form[action*="/cart/add.js"]').forEach(function(form){
      if(form.closest('[data-womn-native-rsi-host]')||closestRsiSurface(form))add(form);
    });
    scopes.forEach(function(scope){syncRsiScope(scope,variantId,quantity);});
    return data;
  }
  function syncLeadFields(data){
    if(leadPack)leadPack.textContent=data.title;if(leadPrice)leadPrice.textContent=data.price;
    if(!leadForm)return;
    var map={selected_pack:data.title,selected_price:data.price,selected_mrp:data.mrp,selected_discount:data.save,selected_day_price:data.day};
    Object.keys(map).forEach(function(name){var f=leadForm.querySelector('[name="'+name+'"]');if(f)f.value=map[name]});
  }
  function syncOffer(card){
    selectedOffer=card||selectedOffer;
    var data=offerData(selectedOffer);
    if(stickyName)stickyName.textContent=data.title;if(stickyPrice)stickyPrice.textContent=data.price;if(stickyMrp)stickyMrp.textContent=data.mrp;
    if(mainPrice)mainPrice.textContent=data.price;if(mainMrp)mainMrp.textContent=data.mrp;if(mainSave)mainSave.textContent=data.save;
    if(mainCta)mainCta.textContent='BUY NOW — '+data.price;
    syncLeadFields(data);
    syncRsiContext(data);
    return data;
  }
  function openLeadModal(card){
    var data=syncOffer(card||selectedOffer);
    syncRsiContext(data);

    if(window.__WOMN_PACK_ANIMATION_RUNNING)return;
    window.__WOMN_PACK_ANIMATION_RUNNING=true;

    if(!modal){
      setTimeout(function(){
        window.__WOMN_PACK_ANIMATION_RUNNING=false;
        revealReleasitOrderForm();
      },80);
      return;
    }

    modal.style.display='flex';
    modal.style.pointerEvents='auto';
    if(leadForm)leadForm.style.display='none';
    if(releasitBridge){
      releasitBridge.classList.remove('is-ready');
      releasitBridge.setAttribute('aria-hidden','true');
    }
    if(leadSubmit){
      leadSubmit.disabled=true;
      leadSubmit.textContent='Opening order form...';
    }

    modal.classList.remove('is-open');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');

    setTimeout(function(){
      window.__WOMN_PACK_ANIMATION_RUNNING=false;
      revealReleasitOrderForm();
    },980);
  }
  function closeLeadModal(){if(modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');modal.style.pointerEvents='none';setTimeout(function(){if(!modal.classList.contains('is-open')){modal.style.display='none';}},260)}}

  /* Final Releasit bridge:
     The app hook is warmed on the real page from first paint. After WhatsApp capture,
     the WOMN modal closes first, then the real Releasit-injected button is clicked once.
     No product-page, checkout, Pay Online, or COD redirect is used. */
  var womnRsiClickAttempted=false;
  function getNativeRsiButton(){
    var host=document.querySelector('[data-womn-native-rsi-host]');
    if(!host)return null;
    var selectors=[
      '._rsi-cod-form-gempages-button-hook button:not([disabled])',
      '._rsi-cod-form-gempages-button-hook a[href]:not([aria-disabled="true"])',
      'button.rsi-cod-form-gempages-button-overwrite:not([disabled])',
      'a.rsi-cod-form-gempages-button-overwrite[href]',
      'button:not([disabled])',
      'a[href]:not([aria-disabled="true"])',
      '[role="button"]:not([aria-disabled="true"])'
    ];
    for(var i=0;i<selectors.length;i++){
      var nodes=host.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++){
        var el=nodes[j];
        if(el.closest('[data-womn-manual-rsi]')||el.classList.contains('womn-manual-rsi'))continue;
        if((el.textContent||'').trim().length===0 && el.tagName!=='BUTTON')continue;
        return el;
      }
    }
    return null;
  }
  function setRsiStatus(text){var status=document.querySelector('[data-womn-rsi-status]');if(status)status.textContent=text;}
  function clickElement(el){
    if(!el)return false;
    try{el.click();return true;}catch(err){}
    try{el.dispatchEvent(new MouseEvent('click',{view:window,bubbles:true,cancelable:true}));return true;}catch(e){}
    return false;
  }
  function openReleasitOnce(maxMs){
    if(womnRsiClickAttempted)return;
    var started=Date.now();
    var host=document.querySelector('[data-womn-native-rsi-host]');
    var observer=null,done=false;
    setRsiStatus('Opening secure COD form...');
    syncRsiContext(offerData(selectedOffer));
    function finish(){if(done)return;done=true;if(observer)observer.disconnect();}
    function attempt(){
      if(done)return true;
      var data=syncRsiContext(offerData(selectedOffer));
      var btn=getNativeRsiButton();
      if(!btn)return false;
      womnRsiClickAttempted=true;
      finish();
      closeLeadModal();
      setTimeout(function(){
        if(modal){modal.style.display='none';modal.style.pointerEvents='none';}
        syncRsiContext(data,btn);
        clickElement(btn);
      },120);
      return true;
    }
    if(attempt())return;
    if(host && window.MutationObserver){
      observer=new MutationObserver(function(){attempt();});
      observer.observe(host,{childList:true,subtree:true,attributes:true});
    }
    [180,420,900,1600,Math.max(2200,maxMs||2600)].forEach(function(delay){
      setTimeout(function(){
        if(attempt())return;
        if(Date.now()-started>=(maxMs||2600)){
          finish();
          setRsiStatus('Releasit button is not loaded yet. Keep the Releasit COD Form app embed ON for this theme.');
          if(leadSubmit){leadSubmit.disabled=false;leadSubmit.textContent='Open order form';}
        }
      },delay);
    });
  }
  function revealReleasitOrderForm(){
    /* Match the live product-page style: keep a real Shopify/Releasit product
       context warmed on the page, close the WOMN lead layer first, then click
       the native Releasit hook once. No product-page redirect, checkout redirect,
       or fake outside payment button is introduced here. */
    if(releasitBridge){releasitBridge.classList.remove('is-ready');releasitBridge.setAttribute('aria-hidden','true');}
    if(leadSubmit){leadSubmit.disabled=true;leadSubmit.textContent='Opening order form...'}
    closeLeadModal();
    if(modal){modal.style.pointerEvents='none';setTimeout(function(){if(modal&&!modal.classList.contains('is-open'))modal.style.display='none';},180);}
    womnRsiClickAttempted=false;
    setRsiStatus('Opening secure COD form...');
    setTimeout(function(){openReleasitOnce(2600);},220);
  }

  document.querySelectorAll('[data-offer-card]').forEach(function(card){
    card.addEventListener('click',function(){
      document.querySelectorAll('[data-offer-card]').forEach(function(c){c.classList.remove('selected');c.setAttribute('aria-checked','false')});
      card.classList.add('selected');card.setAttribute('aria-checked','true');
      syncOffer(card); openLeadModal(card);
    });
    card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();card.click()}});
  });
  document.querySelectorAll('[data-main-cta],[data-womn-buy-trigger]').forEach(function(btn){
    btn.addEventListener('click',function(e){e.preventDefault();openLeadModal(selectedOffer)});
  });
  if(leadClose)leadClose.addEventListener('click',closeLeadModal);
  if(modal)modal.addEventListener('click',function(e){if(e.target===modal)closeLeadModal()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLeadModal()});
  if(leadForm){
    leadForm.addEventListener('submit',function(e){
      e.preventDefault();
      var data=offerData(selectedOffer),input=leadForm.querySelector('[name="whatsapp_number"]');
      if(input && !input.checkValidity()){input.reportValidity();return}
      syncRsiContext(data);
      var lead={whatsapp_number:input.value.trim(),selected_pack:data.title,selected_price:data.price,selected_mrp:data.mrp,selected_discount:data.save,selected_day_price:data.day,selected_variant_id:data.variantId||'',selected_quantity:data.quantity||'1',captured_at:new Date().toISOString(),source_page:window.location.href};
      window.WOMN_SELECTED_ORDER=lead;
      try{var saved=JSON.parse(localStorage.getItem('womn_whatsapp_leads')||'[]');saved.push(lead);localStorage.setItem('womn_whatsapp_leads',JSON.stringify(saved));}catch(err){}
      window.dispatchEvent(new CustomEvent('womn:leadCaptured',{detail:lead}));
      if(window.WOMNLeadBridge&&typeof window.WOMNLeadBridge.onCapture==='function'){window.WOMNLeadBridge.onCapture(lead)}
      var endpoint=leadForm.getAttribute('data-lead-endpoint');
      if(endpoint){try{fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(lead),keepalive:true});}catch(err){}}
      if(leadSubmit){leadSubmit.disabled=true;leadSubmit.textContent='Opening order form...'}
      revealReleasitOrderForm();
    });
  }

  var manualRsi=document.querySelector('[data-womn-manual-rsi]');
  if(manualRsi){
    manualRsi.addEventListener('click',function(){
      setRsiStatus('Opening secure COD form...');
      syncRsiContext(offerData(selectedOffer));
      var btn=getNativeRsiButton();
      if(btn){closeLeadModal();setTimeout(function(){if(modal){modal.style.display='none';modal.style.pointerEvents='none';} syncRsiContext(offerData(selectedOffer),btn);clickElement(btn);},120);}else{setRsiStatus('Releasit button is not loaded yet. Keep Releasit COD Form app embed ON.');}
    });
  }


  function normalizeText(text){return String(text||'').replace(/\s+/g,' ').trim().toLowerCase();}
  function directButtonSignal(btn){
    if(!btn)return '';
    var parts=[];
    parts.push(btn.innerText||btn.textContent||btn.value||'');
    if(btn.getAttribute){
      parts.push(btn.getAttribute('aria-label')||'');
      parts.push(btn.getAttribute('title')||'');
      parts.push(btn.getAttribute('href')||'');
      parts.push(btn.getAttribute('data-href')||'');
      parts.push(btn.getAttribute('data-url')||'');
      parts.push(btn.getAttribute('name')||'');
      parts.push(btn.getAttribute('id')||'');
      parts.push(btn.getAttribute('class')||'');
    }
    try{
      btn.querySelectorAll('img[alt],svg[aria-label],[title],[aria-label]').forEach(function(node){
        parts.push(node.getAttribute('alt')||node.getAttribute('aria-label')||node.getAttribute('title')||'');
      });
    }catch(err){}
    return normalizeText(parts.join(' '));
  }
  function whatsappBridgeUrl(){
    var cfg=window.WOMN_RSI_PAYMENT_BRIDGE||{};
    return cfg.whatsapp_url||'https://wa.me/919871858886';
  }
  function isWhatsappButton(btn,signal){
    signal=signal||directButtonSignal(btn);
    var href=(btn&&btn.getAttribute?btn.getAttribute('href'):'')||'';
    var host='';
    try{host=new URL(href,window.location.origin).hostname.toLowerCase();}catch(err){}
    return signal.indexOf('buy on whatsapp')>-1||
      signal.indexOf('on whatsapp')>-1||
      signal.indexOf('whatsapp')>-1||
      signal.indexOf('wa.me')>-1||
      host==='wa.me'||host.indexOf('whatsapp')>-1;
  }
  function isNativeCodButton(btn,signal){
    signal=signal||directButtonSignal(btn);
    if(isWhatsappButton(btn,signal))return false;
    if(signal.indexOf('pay online')>-1||signal.indexOf('pay now')>-1)return false;
    return signal.indexOf('cash on delivery')>-1||
      signal.indexOf('cash-on-delivery')>-1||
      signal.indexOf('pay on delivery')>-1||
      /\bcod\b/.test(signal)||
      (signal.indexOf('buy now')>-1&&signal.indexOf('delivery')>-1);
  }
  function forceTopWhatsAppRedirect(){
    var url=whatsappBridgeUrl();
    try{window.__WOMN_WHATSAPP_REDIRECTING_AT=Date.now();}catch(flagErr){}
    try{if(window.top&&window.top!==window){window.top.location.href=url;return;}}catch(err){}
    try{window.location.href=url;return;}catch(e){}
    try{window.location.assign(url);return;}catch(assignErr){}
    try{window.location.replace(url);}catch(lastErr){}
  }
  function normalizeWhatsappLinks(root){
    if(!root||!root.querySelectorAll)return;
    root.querySelectorAll('a[href],button,[role="button"],input[type="button"],input[type="submit"]').forEach(function(a){
      var signal=directButtonSignal(a);
      if(!isWhatsappButton(a,signal))return;
      if(a.closest('[data-womn-lead-modal]'))return;
      if(a.tagName==='A'){
        a.setAttribute('href',whatsappBridgeUrl());
        a.setAttribute('target','_top');
        a.setAttribute('rel','noopener noreferrer');
      }
    });
  }
  function handleReleasitPaymentClick(e){
    var btn=e.target&&e.target.closest?e.target.closest('button,a,[role="button"],input[type="button"],input[type="submit"]'):null;
    if(!btn)return;
    if(btn.closest('[data-womn-lead-modal]'))return;
    var cfg=window.WOMN_RSI_PAYMENT_BRIDGE||{};
    if(cfg.enable_whatsapp_listener===false||cfg.enable_whatsapp_listener==='false')return;
    var signal=directButtonSignal(btn);

    if(isWhatsappButton(btn,signal)){
      var last=0;try{last=window.__WOMN_WHATSAPP_REDIRECTING_AT||0;}catch(err){}
      if(Date.now()-last<1400){e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();return;}
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      forceTopWhatsAppRedirect();
      return;
    }

    if(isNativeCodButton(btn,signal)){
      try{syncRsiContext(offerData(selectedOffer),btn);}catch(syncErr){}
      return;
    }
  }
  function installReleasitPaymentBridge(){
    if(window.__WOMN_RSI_PAYMENT_BRIDGE_INSTALLED)return;
    window.__WOMN_RSI_PAYMENT_BRIDGE_INSTALLED=true;
    normalizeWhatsappLinks(document);
    if(window.MutationObserver){
      var whatsappObserver=new MutationObserver(function(records){
        records.forEach(function(record){
          record.addedNodes&&record.addedNodes.forEach(function(node){
            if(node&&node.nodeType===1)normalizeWhatsappLinks(node);
          });
        });
      });
      whatsappObserver.observe(document.documentElement,{childList:true,subtree:true});
    }
    ['pointerup','touchend','click'].forEach(function(type){
      document.addEventListener(type,handleReleasitPaymentClick,true);
    });
  }
  installReleasitPaymentBridge();

  syncOffer(selectedOffer);
  var toast=document.querySelector('[data-womn-toast]'); if(toast){setTimeout(function(){toast.classList.add('show')},1200);setTimeout(function(){toast.classList.remove('show')},6200)}
  document.querySelectorAll('.womn-faq details').forEach(function(d){d.addEventListener('toggle',function(){if(d.open){document.querySelectorAll('.womn-faq details').forEach(function(o){if(o!==d)o.open=false})}})});
})();

(function(){
  var bs=[
    document.getElementById('wb1'),
    document.getElementById('wb2'),
    document.getElementById('wb3'),
    document.getElementById('wb4')
  ];
  var pf = document.getElementById('wbl-pf');
  var delays = [87, 435, 783, 1130];
  var pcts   = ['25%','50%','75%','100%'];

  delays.forEach(function(d,i){
    setTimeout(function(){
      if(bs[i]) bs[i].classList.add('on');
      if(pf) pf.style.width = pcts[i];
    }, d);
  });

  // Fade out loader after all 4 up + 0.9s hold
  setTimeout(function(){
    var w = document.getElementById('wbl');
    if(w){ w.classList.add('wbl-out'); setTimeout(function(){ w.remove(); }, 430); }
  }, 1565);
})();
